import axios from '../../../../apis/Api'
import history, { logout } from '../../../../history'
import storage from '../../../../apis/Storage'
import {
  ADD_PAGE_ACTION,
  DELETE_PAGE_ACTION,
  GET_PAGE_ACTIONS,
  GET_USER_ROLE_PERMISSIONS,
} from '../../../../Types'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'

export const getPageActions = () => async (dispatch) => {
  await axios
    .get(`api/PageAction`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_PAGE_ACTIONS,
        payload: data,
      })
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const getPageAndActionsList = () => async (dispatch) => {
  await axios
    .get(`api/UserRolePageActionPermission/GetPageWithActions`)
    .then(({ data }) => {
      // if (data && data.length > 0)
      dispatch({
        type: GET_USER_ROLE_PERMISSIONS,
        payload: data,
      })
    })
    .catch(function (error) {
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}

export const addPageAction = (formValues) => async (dispatch) => {
  dispatch(showLoading())
  await axios
    .post('api/PageAction', formValues)
    .then(({ data }) => {
      if (data.response)
        dispatch({
          type: ADD_PAGE_ACTION,
          payload: data.response,
        })
      dispatch(hideLoading())
      toast.success('Page action added successfully')
    })
    .catch(function (error) {
      dispatch(hideLoading())
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = ''
          var errors = error.response.data.errors
          var keys = Object.keys(errors)
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + ' , \n'
          }
          toast.error(errorMessage)
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      } else toast.error('Error while processing the request')
    })
}

export const deletePageAction = (id) => async (dispatch) => {
  const config = {
    headers: { Authorization: `Bearer ${storage.get('_appToken')}` },
  }

  await axios
    .delete(`api/PageAction/${id}`, config)
    .then(() => {
      toast.success('Page action deleted successfully')
      dispatch({ type: DELETE_PAGE_ACTION, payload: id })
    })
    .catch(function (error) {
      dispatch(hideLoading())
      toast.error('Error: ' + error)
      if (error.response) {
        if (error.response.status === 401) {
          logout()
          history.push('/login')
          history.go('/login')
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          )
        else {
          toast.error('Error while processing the request')
        }
      }
    })
}
